import { createStyles } from '@material-ui/core';

export default createStyles({
    badge: {
        height: '1.6rem',
        minWidth: '1.6rem',
        fontSize: '1.2rem',
    },
});
